import { environment } from "../../environment";
import { getApiEndpoint } from "../../utils/constants/api";
import { PAGE_TEMPLATES } from "../../utils/constants/templates";
import { wfetch } from "../../utils/fetch";

export const FETCH_DYNAMIC_PAGES = "FETCH_DYNAMIC_PAGES";

export const fetchDynamicPages = (appBase = environment.APP_BASE) => {
    return async (dispatch) => {
        const response = await wfetch(
            getApiEndpoint("PAGES", {
                pathParams: { path: "" },
                queryParams: {
                    "@ancestor": appBase,
                    "mgnl:template": `${PAGE_TEMPLATES.PRODUCT_OVERVIEW}|${PAGE_TEMPLATES.PRODUCT_DETAIL}`,
                },
            }),
        );

        // Dispatch even when empty: switching to a shop without product pages must clear the
        // previous shop's paths instead of silently keeping them.
        if (!response) return;

        const payload = {};

        for (const page of response.data.results) {
            payload[page["mgnl:template"]] = page["@path"];
        }

        dispatch({
            type: FETCH_DYNAMIC_PAGES,
            payload,
        });
    };
};
